import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import ReactDOM from 'react-dom';
import { useHistory, useLocation } from 'react-router-dom';

import { getUID } from '@atlas/core';

import { useNotificationsUIContext } from 'common/Popup/NotificationsUIContext';
import { casinoFilterTypeMap, getFilter } from 'components/Pages/Casino/useCasinoFilter';

export const MODAL_ROOT_NODE_ID = 'modal-root';
const modalRoot = document.getElementById(MODAL_ROOT_NODE_ID);

const popupWrapperClassName = 'popup-backdrop';

function createModalRootElement(options) {
  const element = document.createElement('div');
  element.className = options.className; // 'modal-window'

  return element;
}

export default function ModalPortal({ backdropOff, children, className = '' }) {
  const rootRef = useRef(null);
  const { push: historyPush } = useHistory();
  const { pathname } = useLocation();
  const { emitPopupToggle } = useNotificationsUIContext();
  const searchCasinoQuery = getFilter(casinoFilterTypeMap.name);

  const redirectUrl = useMemo(() => {
    if (searchCasinoQuery) return `${pathname}?${casinoFilterTypeMap.name}=${searchCasinoQuery}`;
    return pathname;
  }, [pathname, searchCasinoQuery]);

  const closePopup = useCallback(
    e => {
      if (e.nativeEvent.srcElement.className !== popupWrapperClassName) return;

      historyPush(redirectUrl);
    },
    [historyPush, redirectUrl],
  );

  useEffect(() => {
    const modalId = getUID();

    modalRoot.appendChild(rootRef.current);
    emitPopupToggle(modalId);

    return () => {
      rootRef.current.remove();
      emitPopupToggle(modalId);
    };
  }, []);

  if (!rootRef.current) {
    rootRef.current = createModalRootElement({
      className: `popup popup-z-index ${className}`,
    });
  }

  if (backdropOff) {
    return ReactDOM.createPortal(children, rootRef.current);
  }
  return ReactDOM.createPortal(
    <div className={popupWrapperClassName} onClick={closePopup}>
      {children}
    </div>,
    rootRef.current,
  );
}
